import React, { useState } from 'react';
import './CTA.css';
import PartnershipModal from './PartnershipModal';

function CTA() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section className="cta">
      <div className="cta-container">
        <h2 className="heading-md">Ready to Get Started?</h2>
        <p className="heading-sm cta-description">
          Join thousands of businesses that have secured financing through Credithai. Start your application today
          and take your business to the next level.
        </p>
        <button className="btn btn-primary" onClick={() => setIsModalOpen(true)}>
          Apply Now
          <img src="/icons/arrow-right.png" alt="" className="btn-icon" />
        </button>
        <PartnershipModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        <p className="caption-md cta-contact">
          Questions? Contact our team at call 9114151617
        </p>
      </div>
    </section>
  );
}

export default CTA;